module.exports = __webpack_public_path__ + "media/images/lb/650-1ecd7cbb0f7ba859829c4625fb50900c.svg";